// extracted by mini-css-extract-plugin
module.exports = {"modal-title":"alertContext_modal-title__Y4tB3","modal-content":"alertContext_modal-content__biBVt","modal-footer":"alertContext_modal-footer___dJR3"};